import type { AllRouteEndpoints } from "../routeTypes";

export const patchApiCalculatedFiltersAppGroupIdArchiveCacheKeys: AllRouteEndpoints[] = [
  "/api/calculated_filters/:app_group_id",
  "/api/calculated_filters/:id/:app_group_id",
];
